import { reactLocalStorage } from "reactjs-localstorage";
const uuid = require("uuid");
const userKey = "igUser";
const uuidKey = "igUuid";

export const generateUUID = () => {
  // Huella ESTABLE del navegador.
  //
  // Antes se calculaba con navigator.userAgent, y ese texto CAMBIA cada vez que
  // Chrome/Edge se actualiza: el sistema creia que era un navegador nuevo, gastaba
  // los 2 permitidos y el cliente terminaba bloqueado ("Browser limit reached")
  // sin haber compartido su cuenta con nadie.
  //
  // Ahora se genera un identificador aleatorio UNA sola vez y se guarda. Mientras
  // el cliente no borre los datos del navegador, sigue siendo el mismo para
  // siempre, aunque lo actualice. Otra maquina u otro navegador si genera uno
  // distinto, asi que el limite sigue protegiendo igual.
  const guardado = reactLocalStorage.get(uuidKey, "");
  if (guardado) return guardado;

  const uuidResult =
    typeof crypto !== "undefined" && crypto.randomUUID
      ? crypto.randomUUID()
      : uuid.v4();

  saveUUID(uuidResult);
  return uuidResult;
};

export const getUUID = () => {
  const uuid = reactLocalStorage.get(uuidKey, "");
  return uuid ? uuid : generateUUID();

};

export const saveUUID = (uuidData)=>{
  reactLocalStorage.set(uuidKey, uuidData);
}

export const getUser = () => reactLocalStorage.getObject(userKey);
export const saveUser = (user) => reactLocalStorage.setObject(userKey, user);
export const clearAll = () => {
  const uuidR = getUUID();
  reactLocalStorage.clear();
  saveUUID(uuidR); //UUID should be keep even if browser close session.
};
